const COVERURL =
  'https://images.unsplash.com/photo-1590732488817-d34f0d6237a2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80 ';

const sidebarMinWidth = 83;
const sidebarMaxWidth = 247;
const sidebarToggledSize = 1300;

export { COVERURL, sidebarMinWidth, sidebarMaxWidth, sidebarToggledSize };
